import Vue from "vue";
import Vuex from "vuex";
// import cognitoAuthStore from "./store/cognitoAuth";
import auth from "./store/auth";
import settings from "./store/settings";
// Custom Sore Moduels
import stock from "./store/stock";
import promotions from "./store/promotions";
import magazines from "./store/magazines";
import locations from "./store/locations";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    settings,
    stock,
    promotions,
    magazines,
    locations
  }
});
